import React, { useState, useEffect } from "react";
import { stories } from "../data/stories";
import { getFromStorage, saveToStorage } from "../utils/localStorage";
import ProgressBar from "./ProgressBar";

const StoryComponent = ({ locationId, onComplete }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isWaiting, setIsWaiting] = useState(false);
  const [waitingProgress, setWaitingProgress] = useState(0);
  const [waitingInterval, setWaitingInterval] = useState(null);

  const story = stories[locationId];
  const currentText = story.text[currentIndex];

  useEffect(() => {
    // Check if story is already completed
    const completedStories = getFromStorage("completedStories", []);
    if (completedStories.includes(locationId)) {
      onComplete();
      return;
    }

    // Handle waiting periods
    if (currentText && currentText.type === "waiting") {
      setIsWaiting(true);
      setWaitingProgress(0);

      const interval = setInterval(() => {
        setWaitingProgress((prev) => {
          const newProgress = prev + 100 / (currentText.duration / 100);
          if (newProgress >= 100) {
            clearInterval(interval);
            setIsWaiting(false);
            setCurrentIndex((prev) => prev + 1);
            return 100;
          }
          return newProgress;
        });
      }, 100);

      setWaitingInterval(interval);
    }

    return () => {
      if (waitingInterval) {
        clearInterval(waitingInterval);
      }
    };
  }, [currentIndex, currentText, locationId, onComplete]);

  const handleContinue = () => {
    if (isWaiting) return;

    if (currentIndex < story.text.length - 1) {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => prev + 1);
        setIsVisible(true);
      }, 300);
    } else {
      // Story complete
      const completedStories = getFromStorage("completedStories", []);
      if (!completedStories.includes(locationId)) {
        completedStories.push(locationId);
        saveToStorage("completedStories", completedStories);
      }
      onComplete();
    }
  };

  if (!story) {
    onComplete();
    return null;
  }

  return (
    <div className="story-container">
      <div className="story-header">
        <h1>{story.locationName}</h1>
      </div>

      <div className="story-content">
        <div className={`story-text ${isVisible ? "visible" : "hidden"}`}>
          {currentText && currentText.type !== "waiting" ? (
            <div>
              {currentText.split("\t").map((paragraph, index) => (
                <p
                  key={index}
                  style={{
                    marginBottom:
                      index < currentText.split("\t").length - 1 ? "1rem" : "0",
                  }}
                >
                  {paragraph}
                </p>
              ))}
            </div>
          ) : (
            <ProgressBar
              progress={waitingProgress}
              label="Loading..."
              showPercentage={true}
            />
          )}
        </div>

        {!isWaiting && (
          <button className="menu-button" onClick={handleContinue}>
            Continue
          </button>
        )}
      </div>
    </div>
  );
};

export default StoryComponent;
